<template>
  <div class="main">
    <div class="main_bg">
      <div class="main2-content">
        <div style="height: 50px"></div>
        <div class="layout-flex">
          <div class="layout-flex-1">
            <div
              class="select-content"
              v-for="(item, index) in selectList"
              :key="index"
            >
              <div class="select-title">{{ item.brand_name }}</div>
              <div
                class="select-item"
                :class="{ 'select-active': item.select }"
                @click="handleAll(item, item.typeList)"
              >
                ALL
              </div>
              <div
                class="select-item"
                v-for="(item2, index2) in item.typeList"
                :key="index2"
                :class="{ 'select-active': item2.select }"
                @click="handleDetail(item, item2)"
              >
                {{ item2.typeName }}
              </div>
            </div>
          </div>

          <div class="layout-flex-2">
            <div class="select-dec">{{ brandDetail.intro }}</div>
            <div v-for="(item, index) in selectDetail" :key="index">
              <div class="detail-typeName">{{ item.typeName }}</div>
              <div class="detail-carList">
                <div
                  class="detail-car"
                  v-for="(item2, index2) in item.carList"
                  :key="index2"
                >
                  <div class="car-img">
                    <img :src="item2.picturePath" style="width: 100%" />
                  </div>
                  <div class="car-name">{{ item2.title }}</div>
                  <div class="model-content">
                    <div class="car-title">{{ item2.title }}</div>
                    <div class="car-dec" v-html="item2.introduction"></div>
                  </div>
                </div>
              </div>
              <div style="clear: both"></div>
            </div>
          </div>
        </div>
        <div style="height: 120px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "./config";
import { csvw_url } from "../../components/config";
export default {
  name: "factoryPc",
  components: {},
  data() {
    return {
      index: 0,
      selectList: [],
      brandDetail: "",
      selectDetail: "",
    };
  },
  mounted() {
    this.index = this.$route.query.index || 0;
    this.getList();
  },
  methods: {
    getList() {
      // for (let i = 0; i < 5; i++) {
      //   let item = {
      //     brand_name: "SKODA",
      //     intro:
      //       "SAIC VOLKSWAGEN covers different market segments such as A0, A, B, C, SUV and MPV with a dozen of series models under VW brand and Skoda brand. VW brand includes All New Polo Plus, Santana family, Lavida family, Lamando, Passat, PHIDEON, Tiguan, Teramont, Tharu, T-Cross, Touran, Viloran. Skoda brand includes RAPID, RAPID SPACEBACK, OCTAVIA, SUPERB, KODIAQ, KAROQ, KAMIQ.",
      //     introduction:
      //       "<p>安亭汽车一厂是上汽大众最早的轿车生产基地，位于上海安亭。</p>",
      //     sort: 9,
      //     select: false,
      //     typeList: [
      //       {
      //         typeName: "SUV",
      //         typeId: "SUV",
      //         sort: 8,
      //         select: false,
      //         carList: [
      //           {
      //             intro:
      //               "All New Polo Plus, based on MQB platform, was launched in June, 2019. The new generation upgraded comprehensively in design, driving, pleasure and safety, setting a new benchmark for urban hatchbacks.",
      //             introduction:
      //               "<p>安亭汽车一厂是上汽大众最早的轿车生产基地，位于上海安亭。</p>",
      //             mobilePicturePath: require("../../assets/english/imgs/3001.png"),
      //             picturePath: require("../../assets/english/imgs/3001.png"),
      //             sort: 9,
      //             subTitle: null,
      //             title: "New Santana"
      //           },
      //           {
      //             intro:
      //               "was launched in June, 2019. The new generation upgraded comprehensively in design, driving, pleasure and safety, setting a new benchmark for urban hatchbacks.",
      //             introduction:
      //               "<p>安亭汽车一厂是上汽大众最早的轿车生产基地，位于上海安亭。</p>",
      //             mobilePicturePath: require("../../assets/english/imgs/3002.png"),
      //             picturePath: require("../../assets/english/imgs/3002.png"),
      //             sort: 9,
      //             subTitle: null,
      //             title: "All New Lavida"
      //           }
      //         ]
      //       },
      //       {
      //         typeName: "SUV2",
      //         typeId: "SUV2",
      //         sort: 9,
      //         select: false,
      //         carList: [
      //           {
      //             intro:
      //               "All New Polo Plus, based on MQB platform, was launched in June, 2019. The new generation upgraded comprehensively in design, driving, pleasure and safety, setting a new benchmark for urban hatchbacks.setting a new benchmark for urban hatchbacks.setting a new benchmark for urban hatchbacks.",
      //             introduction:
      //               "<p>安亭汽车一厂是上汽大众最早的轿车生产基地，位于上海安亭。</p>",
      //             mobilePicturePath: require("../../assets/english/imgs/3002.png"),
      //             picturePath: require("../../assets/english/imgs/3002.png"),
      //             sort: 9,
      //             subTitle: null,
      //             title: "All New Lavida"
      //           }
      //         ]
      //       }
      //     ]
      //   };
      //   this.selectList.push(item);
      // }
      // this.brandDetail = this.selectList[0];
      // this.selectDetail = this.selectList[0].typeList;

      this.selectList = [];
      this.axios
        .get(`${csvw_url}/front/news/tcEngCarTypeBrand/list`)
        .then((res) => {
          console.log(res);
          let list = res.data.data;
          list.forEach((item) => {
            item.typeList.forEach((item2) => {
              item2.carList.forEach((item3) => {
                item3.picturePath = `${csvw_url}${item3.picturePath}`;
                item3.mobilePicturePath = `${csvw_url}${item3.mobilePicturePath}`;
              });
            });
          });

          if (this.index == -1) {
            this.selectList = list;
          } else {
            this.selectList = [list[this.index]];
          }
          this.brandDetail = this.selectList[0];
          this.selectDetail = this.selectList[0].typeList;
          // if (this.selectList.length) {
          //   this.selectList[0].select = true;
          //   this.selectDetail = this.selectList[0];
          // } else {
          //   console.log("暂无数据");
          // }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    },
    handleAll(item, item2) {
      this.selectList.forEach((item) => {
        item.select = false;
        item.typeList.forEach((item2) => {
          item2.select = false;
        });
      });
      item.select = true;
      this.brandDetail = item;
      this.selectDetail = item2;
      console.log(this.selectDetail);
    },
    handleDetail(item, item2) {
      this.selectList.forEach((item) => {
        item.select = false;
        item.typeList.forEach((item2) => {
          item2.select = false;
        });
      });
      item2.select = true;
      this.brandDetail = item;
      this.selectDetail = [item2];
      console.log(this.selectDetail);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 1200px;
  margin: 0px auto;
  font-size: 14px;
  font-family: "Microsoft Yahei", "微软雅黑";
}

.main_bg {
  width: 100%;
  min-width: 1200px;
  background: #f5f5f5;
  background-image: url("../../assets/english/imgs/brandBg@2x.png");
  background-size: 100%;
}

.main2-content {
  width: calc(100% - 60px);
  margin: 0px 30px;
}

.layout-flex {
  width: 1200px;
  display: flex;
  margin-left: auto;
  margin-right: auto;
}

.layout-flex-1 {
  width: 250px;
  .select-content {
    background: #ffffff;
    margin-bottom: 20px;
    padding-bottom: 15px;
  }
  .select-title {
    height: 50px;
    font-size: 18px;
    font-weight: 800;
    color: #343434;
    line-height: 50px;
    padding-left: 30px;
  }
  .select-item {
    position: relative;
    height: 36px;
    font-size: 15px;
    font-weight: 400;
    color: #343434;
    line-height: 36px;
    box-sizing: border-box;
    padding-left: 30px;
    cursor: pointer;
  }
  .select-active {
    color: #ffffff;
    background: #999999;
  }
}

.layout-flex-2 {
  width: 920px;
  margin-left: 30px;
  .select-dec {
    font-weight: 400;
    color: #343434;
    line-height: 18px;
    margin-top: 14px;
    height: 70px;
  }
  .detail-typeName {
    font-size: 18px;
    font-weight: 800;
    color: #343434;
    line-height: 45px;
  }
}

.detail-carList {
}

.detail-car {
  position: relative;
  width: 285px;
  margin-right: 15px;
  margin-bottom: 15px;
  float: left;
  .car-img {
    width: 285px;
    height: 115px;
    padding-top: 20px;
  }
  .car-name {
    font-weight: 400;
    color: #343434;
    line-height: 45px;
    padding-bottom: 10px;
  }
  //膜层
  .model-content {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    background: #000000;
    opacity: 0.85;
    top: 0px;
    left: 0px;
    overflow: auto;
    .car-title {
      height: 38px;
      color: #ffffff;
      line-height: 38px;
      text-align: center;
    }
    .car-dec {
      font-size: 12px;
      color: #ffffff;
      padding: 0px 5px;
      /deep/p {
        margin: 0px;
      }
    }
  }
}

.detail-car:hover .model-content {
  display: block;
  cursor: pointer;
}

@media screen and (min-width: 1600px) {
  .main2-content {
    .layout-flex {
      width: 1600px;
      .layout-flex-1 {
        width: 350px;
      }
      .layout-flex-2 {
        width: 1220px;
      }
    }
  }
}
</style>
